import React from "react"

export const Options = ({ plans }) => {
	console.log("plans", plans)

	const BasePrice = plans.Monthly.price
	console.log("BasePrice", BasePrice)

	return (
		<div
			className="row justify-content-space-between"
			style={{
				"--gap-s": "0px",
				"--gap-m": "20px"
			}}
		>
			{Object.keys(plans).map((plan, index) => {
				return (
					<div className={`col-12 col-md-fluid option ${plan === "Monthly" ? "base" : ""}`}>
						<strong>{plan}</strong>
						<p className="price">
							<span className="dollar">£</span>
							<span className="amount">{plans[plan].price} </span>
							<span className="period">every {plans[plan].frequency} </span>
							{plan === "Monthly" ? "" : <span className="savings">{(1 - (plans[plan].price * plans[plan].quantity) / (BasePrice * 12)).toFixed(2) * 100}% Savings</span>}
						</p>

						<a
							className="btn"
							href={plans[plan].paymentLink}
						>
							Select Plan
						</a>
					</div>
				)
			})}
		</div>
	)
}
